import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PreFooterCallout from '../components/PreFooterCallout';
import { imageUrl } from '../lib/images';

const STATIC_DETAILS = {
  miljoevurdering: {
    title: 'Miljøvurdering',
    metaTitle: 'Miljøvurdering - Advokatfirmaet Kopp',
    metaDescription:
      'Miljøvurdering Udvalgte planer/programmer og projekter skal i henhold til miljøvurderingsloven miljøvurderes og have en tilladelse, inden de kan vedtages/gennemføres. Miljøvurderingen belyser planen/programmets eller projektets påvirkninger på en række miljømæssige emner, som fx befolkning, natur, vand, jord, luft, klima, kulturarv.',
    paragraphs: [
      'Udvalgte planer/programmer og projekter skal i henhold til miljøvurderingsloven miljøvurderes og have en tilladelse, inden de kan vedtages/gennemføres. Miljøvurderingen belyser planen/programmets eller projektets påvirkninger på en række miljømæssige emner, som fx befolkning, natur, vand, jord, luft, klima, kulturarv.',
      'Miljøvurderingen af planer/programmer og projekterne er en kompleks størrelse, da den drejer sig om langt mere end selve de miljøfaglige vurderinger. Miljøvurderingen er funderet i de juridiske krav til miljøvurderingen og aktualiserer et kompliceret sammenspil mellem teknik, miljø og jura.',
    ],
    image1: 'environmental-protection-326923-1920-1024x683.jpg',
    image2: 'seagulls-8724811-1920-1024x683.jpg',
    minRaadgivningIntro: [
      'Gennemførelse af en miljøvurdering af en plan/program eller et projekt bygger på en juridisk forståelse af kravene til selve miljøvurderingsprocessen. Miljøvurderingen kræver dertil indsigt i en lang række underliggende miljøretlige regler. Det er derfor vigtigt, at denne gennemføres ud fra en korrekt forståelse af disse regler.',
      'Miljøvurderingerne sker således på et juridisk fundament, hvis overholdelse er væsentlig at sikre, så miljøvurderingerne ikke bliver underkendt ved nævn og domstole.',
      'Min mangeårige erfaring med kvalitetssikring af miljøvurderinger er, at omkostningerne ved at få foretaget en juridisk kvalitetssikring af miljøvurderingen, er givet særdeles godt ud, hvis man som myndighed eller bygherre vil undgå unødige tab af fx tid, økonomi og omdømme.',
    ],
    minRaadgivningBullets: [],
  },
  'natur-vand-miljoe': {
    title: 'Natur, Vand & Miljø',
    metaTitle: 'Natur, Vand & Miljø - Advokatfirmaet Kopp',
    metaDescription:
      'Natur, vand og miljø Beskyttelsen af natur, vand og miljø er centrale områder af miljøretten. Områderne består af en lang række love som tilsammen udgør en meget kompleks regulering af aktiviteter i samfundet.',
    paragraphs: [
      'Beskyttelsen af natur, vand og miljø er centrale områder af miljøretten. Områderne består af en lang række love som tilsammen udgør en meget kompleks regulering af aktiviteter i samfundet.',
      'Lovgivningen om natur omfatter fx beskyttelse af Natura 2000-områder, bilag IV-arter og rødlistede arter, fredninger af forskellig art. Lovgivning om vand har fokus på beskyttelse af vandøkosystemer mod forurening og andre typer af påvirkninger, som forringer områdernes kvalitet eller forhindrer deres målopfyldelse.',
      'Beskyttelse af miljøet mod forurening har fokus på luft, vand og jord og er en meget væsentlig del af miljøretten. Reguleringen har til hensigt fx at beskytte mod støj, støv og lugtgener i forbindelse med menneskelige aktiviteter samt minimere og forhindre udledning af skadelige stoffer til luft, jord eller vand.',
      'Alle typer af reguleringer har stor betydning for både projektudviklere, bygherrer og offentlige myndigheder.',
    ],
    image1: 'flowers-276014-1920-1024x651.jpg',
    image2: 'waves-3473335-1920-1024x576.jpg',
    minRaadgivningIntro: [
      'Det kræver stor indsigt at håndtere reguleringen og myndighedskravene korrekt, og der er potentielt store økonomiske risici for både myndighed og bygherre forbundet med en myndighedsbehandling, der ikke lever op til kravene.',
      'For offentlige myndigheder er reguleringen meget kompleks at navigere i, hvorfor der ofte søges råd og vejledning i forbindelse med myndighedsudøvelsen inden for disse områder.',
      'Uanset om man er bygherre eller myndighed rummer lovgivningen derfor store krav i forbindelse med myndighedshåndteringen, herunder fx ved afslag på tilladelser, påbud eller forbud.',
      'En tidlig rådgivning om de juridiske krav og muligheder for håndtering af myndighedskravene er derfor et vigtigt element for at få realiseret sit projekt som bygherre eller leve op til sine myndighedsforpligtelser som offentlig myndighed.',
    ],
    minRaadgivningBullets: [],
  },
  planforhold: {
    title: 'Planforhold',
    metaTitle: 'Planforhold - Advokatfirmaet Kopp',
    metaDescription:
      'Planforhold Projektudvikling på både land og hav kræver kendskab til de planmæssige rammer for arealanvendelsen. Myndighedernes planlægning af arealanvendelsen på land og hav har til hensigt at lave en tidlig samfundsmæssig prioritering af de mange hensyn, der knytter sig til udnyttelse af arealerne.',
    paragraphs: [
      'Projektudvikling på både land og hav kræver kendskab til de planmæssige rammer for arealanvendelsen.',
      'Myndighedernes planlægning af arealanvendelsen på land og hav har til hensigt at lave en tidlig samfundsmæssig prioritering af de mange hensyn, der knytter sig til udnyttelse af arealerne.',
      'Planloven regulerer arealanvendelsen på land. Planloven består af et planlovshierarki med en række forskellige plantyper. Planerne har forskellige retsvirkninger, og mulighederne for at regulere arealanvendelsen på land er nærmere defineret for hver enkelt plantype.',
      'På hav er havplanen et nyere rammesættende planlægningsværktøj. Havplanen vil i samspil med lov om vandplanlægning og havstrategiloven få tiltagende betydning i de kommende år for fx projektudviklere af infrastruktur på hav. Det er vigtigt både som myndighed og bygherre at være opmærksom på de begrænsninger for arealanvendelsen, som disse regler giver samlet set, herunder hvordan rammerne kan ændres.',
    ],
    image1: 'copenhagen-4052654-1920-1-782x1024.jpg',
    image2: 'north-sea-4173180-1920-1024x683.jpg',
    minRaadgivningIntro: [
      'Inden en bygherre starter med projektudvikling af en ejendom eller en myndighed giver en tilladelse til et projekt, er det vigtigt at have godt styr på de planer, som arealet er underlagt. Disse har nemlig stor betydning for, hvilke muligheder der er for gennemførelse af projektet. Min rådgivning drejer sig fx i forbindelse med byudviklingsprojekter eller etablering af infrastruktur om;',
    ],
    minRaadgivningBullets: [
      'Hvad den eksisterende planlægning tillader, at arealet udnyttes til.',
      'Rådgivning og afklaring hos myndighederne om, hvad mulighederne er for at få ændret de planmæssige ramme, såfremt disse ikke kan rumme det påtænkte projekt.',
      'Hvad der kan og/eller forventes at blive stillet af krav fra myndighedens side som led i den ændrede planlægningen fx i forbindelse med udstedelse af lokalplan.',
    ],
  },
  'klima-baeredygtighed': {
    title: 'Klima & Bæredygtighed',
    metaTitle: 'Klima & Bæredygtighed - Advokatfirmaet Kopp',
    metaDescription:
      'Klima og bæredygtighed Kravene til virksomhedernes håndtering af klimapåvirkninger og bæredygtighedstiltag i forbindelse med projektudviklingen har været stærkt tiltagende de seneste år med Taksonomiforordningen og CSRD-direktivet og mere lovgivning er på vej.',
    paragraphs: [
      'Kravene til virksomhedernes håndtering af klimapåvirkninger og bæredygtighedstiltag i forbindelse med projektudviklingen har været stærkt tiltagende de seneste år med Taksonomiforordningen og CSRD-direktivet og mere lovgivning er på vej.',
      'Dertil har en understøttelse af FNs verdensmål fået stor og tiltagende betydning for det offentlige Danmarks ønsker til udviklingen af samfundet. Dette har generelt betydet, at der i flere og flere lovgivninger inden for miljø- og planområdet bliver implementeret ændringer, der styrker varetagelsen af hensyn til særligt klima, natur og ressourceforbrug.',
    ],
    image1: 'hand-4455338-1920-1024x614.jpg',
    image2: 'man-3581659-1920-1024x683.jpg',
    minRaadgivningIntro: [
      'Jeg kan hjælpe med indsigt i lovgivningen og de mange krav, som er vedtaget eller er på vej. Det samspil, som EU-reguleringen i stiende grad tilstræber mellem bæredygtighedsreguleringen og de miljøretlige krav får større og større betydning for, hvordan fx projekter bør projektudvikles i dag, såfremt et projekt skal være fremtidssikret. Min rådgivning relaterer sig særligt til de dele af bæredygtighedsdagsordenen, som har til hensigt at varetage hensyn til klima-, natur- og ressourceforbrug.',
      'Min rådgivning er baseret på praktisk erfaring med ledelse af bæredygtighedsindsatser som led i projektudvikling. Rådgivningen kan bruges af ledelsen til strategisk at tage fremsynede valg i arbejdet med bæredygtigheden.',
    ],
    minRaadgivningBullets: [],
  },
  bygherreraadgivning: {
    title: 'Projektudvikling',
    metaTitle: 'Projektudvikling - Advokatfirmaet Kopp',
    metaDescription:
      'Projektudvikling Som bygherre af infrastruktur eller byggeri er overholdelse af tidsplan og projektøkonomi af stor betydning. Det er derfor afgørende at have overblik over projektudviklingens opgaver og samspillet mellem disse.',
    paragraphs: [
      'Som bygherre af infrastruktur eller byggeri er overholdelse af tidsplan og projektøkonomi af stor betydning. Det er derfor afgørende at have overblik over projektudviklingens opgaver og samspillet mellem disse. Det er som led heri et afgørende element i god projektplanlægning at have et overblik over juraen og de opgaver, der som følge heraf skal udføres.',
      'Min rådgivning har til formål at bibringe mine klienter et tidligt overblik over de juridiske krav til projektudviklingsprocessen og de involverede fagdiscipliner. Min rådgivning bygger på et erfaringsbaseret overblik over hele processen og samspillet mellem fagdisciplinerne. Formålet er at gøre mine klienter i stand til at kunne tilrettelægge processen ud fra en forståelse af de juridiske krav og tilknyttede risici, så der kan træffes bevidste valg om imødegåelse af tab,',
    ],
    image1: 'pier-2405876-1920-1024x683.jpg',
    image2: 'tunnel-4856896-1920-1024x684.jpg',
    minRaadgivningIntro: [
      'Min rådgivning har fokus på at give bygherren det bedst mulige fundament for, at der kan træffes bevidste valg om imødegåelse af risikoen for tab.',
      'Det lykkes jeg med ved at kombinere mine mangeårige kompetencer og erfaringer med',
    ],
    minRaadgivningBullets: [
      'Juridisk analyse og rådgivning på et højt kvalitetsniveau inden for mine fagområder',
      'Sammenspillet mellem miljø, teknik og jura i forbindelse med projektudvikling og gennemførelse af projekter',
      'Strategisk rådgivning og sparring med ledelsen om valg af risikoprofil, og hvordan de valgte mål kan nås uden unødige tab',
      'Planlægning og optimering af myndighedsgodkendelses-processerne, så tid og økonomi beskyttes bedst muligt',
    ],
  },
  'ekspropriation-ledninger-mv': {
    title: 'Anlægslove, ekspropriation, ledninger mv.',
    metaTitle: 'Ekspropriation, ledninger mv. - Advokatfirmaet Kopp',
    metaDescription:
      'Anlægslove, ekspropriation, ledninger mv. Anlægslove giver ofte hjemmel til gennemførelse af ekspropriation, håndtering af servitutter og flytning af ledninger. Jeg har mange års erfaring med regulering gennem anlægslove...',
    paragraphs: [
      'Anlægslove giver ofte hjemmel til gennemførelse af ekspropriation, håndtering af servitutter og flytning af ledninger. Jeg har mange års erfaring med regulering gennem anlægslove, herunder hvilke rettigheder og pligter disse love giver i de konkrete sager, hvor der skal gennemføres en ekspropriation af fast ejendom, overtages eller slettes servitutter eller flyttes ledninger mv.',
      'Der er tale om et kompliceret samspil mellem regler, som berører grundlovens sikrede rettigheder og domstolsskabte principper, som er under stadig udfyldning. Der er desuden tale om indgreb i rettigheder, som typisk får store konsekvenser for dem, der påvirkes at indgrebene.',
    ],
    image1: 'wooden-gavel-books-wooden-table-1024x683.webp',
    image2: 'road-220058-1920-1024x703.jpg',
    minRaadgivningIntro: [
      'Anlægslove skaber deres helt specielle regulering af et givent projekt. Loven og dens bemærkninger har derfor stor betydning ved vurdering af retsstillingen i forhold til fx ekspropriationer, som skal foretages med hjemmel i loven eller ledninger, som skal flyttes af hensyn til anlægsprojektet.',
      'Der er også hjemmel til ekspropriation af private rettigheder i en række andre love fx planloven, hvor betingelserne for ekspropriation vil fremgå særskilt.',
      'Der er findes desuden eksempler på, at ekspropriation opstår utilsigtet som følge af anden form for generel regulering. I disse tilfælde må rækkevidde og konsekvens med domstolenes mellemkomst afklares direkte med afsæt i grundlovens § 73.',
      'Uanset, om man er myndighed eller den, der skal eksproprieres, så er det vigtigt at være repræsenteret af en advokat. En advokat kan bidrage til at sikre, at ekspropriationen lever op til reglerne, herunder at der kun eksproprieres det nødvendige og tilkendes fuldstændig erstatning – hverken mere eller mindre – for indgrebet.',
    ],
    minRaadgivningBullets: [],
  },
};

export default function FagomraadeDetail() {
  const { slug } = useParams();
  const cleanSlug = slug?.replace(/\/+$/, '') || 'miljoevurdering';
  const item = STATIC_DETAILS[cleanSlug] || STATIC_DETAILS.miljoevurdering;

  return (
    <div>
      <SEO
        title={item.metaTitle}
        description={item.metaDescription}
        ogImage={imageUrl(item.image1)}
      />

      {/* Primary Section: 2 Columns */}
      <section className="w-full bg-white py-16 lg:py-24 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
          {/* Left Column: Heading + Paragraphs + Contact CTA */}
          <div className="lg:col-span-7 space-y-6 flex flex-col justify-between">
            <div className="space-y-6">
              <h1 className="text-3xl lg:text-4xl font-bold text-[#34657f]">
                {item.title}
              </h1>

              <div className="space-y-4 text-xs sm:text-sm text-slate-600 leading-relaxed">
                {item.paragraphs.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            </div>

            <div className="pt-4">
              <Link
                to="/kontakt/"
                className="inline-block px-8 py-3.5 bg-[#34657f] hover:bg-[#284f63] text-white text-xs font-semibold uppercase tracking-widest rounded-none transition-colors"
              >
                Kontakt mig her
              </Link>
            </div>
          </div>

          {/* Right Column: First Image */}
          <div className="lg:col-span-5 h-full">
            <div className="w-full h-full min-h-[320px] lg:min-h-full">
              <img
                src={imageUrl(item.image1, 'width=900,height=600,fit=cover,quality=85,format=auto')}
                alt={item.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Secondary Section: "Min rådgivning" (Alternating 2 Columns) */}
      <section className="w-full bg-[#f8f9fa] py-16 lg:py-24 px-6 lg:px-12 border-t border-slate-200">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Column: Second Image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="w-full h-full">
              <img
                src={imageUrl(item.image2, 'width=900,height=600,fit=cover,quality=85,format=auto')}
                alt={`${item.title} rådgivning`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right Column: Min rådgivning text + contact stack */}
          <div className="lg:col-span-7 space-y-6 order-1 lg:order-2">
            <h2 className="text-3xl lg:text-4xl font-bold text-[#34657f]">
              Min rådgivning
            </h2>

            <div className="space-y-4 text-xs sm:text-sm text-slate-600 leading-relaxed">
              {item.minRaadgivningIntro.map((text, idx) => (
                <p key={idx}>{text}</p>
              ))}

              {item.minRaadgivningBullets && item.minRaadgivningBullets.length > 0 && (
                <ul className="list-disc pl-5 space-y-2 pt-2 text-slate-600">
                  {item.minRaadgivningBullets.map((bullet, idx) => (
                    <li key={idx}>{bullet}</li>
                  ))}
                </ul>
              )}
            </div>

            {/* Direct Contact Stack with circular badges - stacked vertically */}
            <div className="pt-4 flex flex-col gap-3 text-sm font-semibold text-[#34657f] w-full">
              <a
                href="tel:004551627235"
                className="inline-flex items-center space-x-3 text-slate-800 hover:text-[#34657f] transition-colors whitespace-nowrap"
              >
                <span className="w-8 h-8 rounded-full bg-[#34657f] text-white flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                </span>
                <span className="whitespace-nowrap">(+45) 5162 7235</span>
              </a>
              <a
                href="mailto:tk@kopplaw.dk"
                className="inline-flex items-center space-x-3 text-slate-800 hover:text-[#34657f] transition-colors whitespace-nowrap"
              >
                <span className="w-8 h-8 rounded-full bg-[#34657f] text-white flex items-center justify-center shrink-0">
                  <i aria-hidden="true" className="fad fa-envelope-open-text text-xs" />
                </span>
                <span className="whitespace-nowrap">tk@kopplaw.dk</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Pre-Footer Callout */}
      <PreFooterCallout />
    </div>
  );
}
